(function () {
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  if (!sentinel) return;

  let loading = false;

  const observer = new IntersectionObserver(async (entries) => {
    const entry = entries[0];
    if (!entry.isIntersecting || loading) return;

    const nextUrl = sentinel.dataset.nextPage;
    if (!nextUrl) {
      observer.disconnect();
      return;
    }

    loading = true;
    sentinel.querySelector('.infinite-scroll-spinner').style.display = 'block';

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Grab new product items
      const newItems = doc.querySelectorAll('#product-grid .grid__item');
      const grid = document.getElementById('product-grid');
      newItems.forEach(item => grid.appendChild(item));

      // Update sentinel for next page
      const newSentinel = doc.getElementById('infinite-scroll-sentinel');
      if (newSentinel && newSentinel.dataset.nextPage) {
        sentinel.dataset.nextPage = newSentinel.dataset.nextPage;
        sentinel.dataset.currentPage = newSentinel.dataset.currentPage;
      } else {
        // No more pages
        sentinel.dataset.nextPage = '';
        observer.disconnect();
        sentinel.style.display = 'none';
      }

      // Re-trigger scroll animations if enabled
      if (typeof window.ScrollTrigger !== 'undefined') {
        window.ScrollTrigger.refresh();
      }

    } catch (err) {
      console.error('Infinite scroll error:', err);
    } finally {
      loading = false;
      sentinel.querySelector('.infinite-scroll-spinner').style.display = 'none';
    }
  }, {
    rootMargin: '200px' // Start loading 200px before the sentinel is visible
  });

  observer.observe(sentinel);
})();